/**
 * 动态加载脚本
 */
export function loadScript(URL, callback) {
  const scripts = document.scripts
  const sLens = scripts.length
  let canLoad = true

  for (let index = 0; index < sLens; index++) {
    const s = scripts.item(index)
    if (s.src && s.src === URL) {
      canLoad = false
      break
    }
  }

  // 如果还未加载当前URL
  if (canLoad) {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = URL
    document.body.appendChild(script)
    script.onload = script.onreadystatechange = function () {
      if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
        callback && callback()
      }
      script.οnlοad = script.onreadystatechange = null
    }
  } else {
    callback && callback()
  }
}

/**
 * 动态加载脚本
 */
export function loadScriptPromise(URL) {
  return new Promise((resolve, reject) => {
    const scripts = document.scripts
    const sLens = scripts.length
    let canLoad = true

    for (let index = 0; index < sLens; index++) {
      const s = scripts.item(index)
      if (s.src && s.src === URL) {
        canLoad = false
        break
      }
    }

    // 如果还未加载当前URL
    if (canLoad) {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = URL
      document.body.appendChild(script)
      script.onload = script.onreadystatechange = function () {
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
          setTimeout(() => {
            resolve()
          }, 0)
        }
        script.οnlοad = script.onreadystatechange = null
      }
      script.onerror = function () {
        reject()
      }
    } else {
      setTimeout(() => {
        resolve()
      }, 0)
    }
  })
}

/**
 * 动态加载css
 */
export function loadStylesheetPromise(URL) {
  return new Promise((resolve, reject) => {
    const scripts = document.scripts
    const sLens = scripts.length
    let canLoad = true

    for (let index = 0; index < sLens; index++) {
      const s = scripts.item(index)
      if (s.src && s.src === URL) {
        canLoad = false
        break
      }
    }

    // 如果还未加载当前URL
    if (canLoad) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = URL
      document.body.appendChild(link)
      link.onload = link.onreadystatechange = function () {
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
          resolve()
        }
        link.οnlοad = link.onreadystatechange = null
      }
      link.onerror = function () {
        reject()
      }
    } else {
      resolve()
    }
  })
}
